/* istanbul ignore file */
export default ({
  palette: {
    primary: { normal }
  }
}) => ({
  modalComponent: {},
  root: {
    visibility: 'hidden',
    position: 'fixed',
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1205,
    backgroundColor: '#fff'
  },

  backdrop: {
    backgroundColor: '#fff',
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 0
  },

  header: {
    border: '0',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '75px'
  },

  title: {
    textTransform: 'uppercase'
  },

  content: {
    backgroundClip: 'border-box',
    position: 'relative'
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  close: {
    background: 'transparent',
    opacity: 1,
    cursor: 'pointer',
    position: 'absolute',
    margin: 0,
    padding: 0,
    right: '20px',
    top: '20px',
    '&:active': {
      boxShadow: 'none'
    },
    '& svg': {
      fill: normal
    }
  },
  icon: {
    '& svg': {
      width: '75px',
      height: '75px',
      fill: normal
    }
  },

  modalIn: {
    transition: 'none',
    pointerEvents: 'auto',
    overflowX: 'hidden',
    overflowY: 'auto',
    visibility: 'visible',
    display: 'block'
  }
});
